import { createFileRoute, Link } from "@tanstack/react-router";
import { SEO } from "~/components/SEO";

export const Route = createFileRoute("/privacy_policy")({
  component: PrivacyPolicy,
});

function PrivacyPolicy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        socialTitle="Ristorante Tennis & Gourmet Morbegno | Privacy Policy"
        description="Informativa sulla privacy di Tennis Gourmet. Scopri come proteggiamo i tuoi dati personali nel rispetto del GDPR e della normativa italiana sulla privacy."
        keywords="privacy policy Tennis Gourmet, GDPR, protezione dati, informativa privacy ristorante"
        url="https://www.ristorantetennisgourmet.it/privacy_policy"
      />
      <section className="tg-section__wrapper pt-25 pb-12 lg:pt-50 lg:pb-25">
        <div className="tg-section__grid">
          <div className="col-span-12 space-y-8 lg:space-y-12 2xl:col-start-3 2xl:col-end-11">
            <div>
              <h2 className="tg-h3 mb-6">Informativa sulla Privacy</h2>
              <p className="tg-body mb-4">
                La presente informativa sulla privacy descrive come Tennis Gourmet
                raccoglie, utilizza e protegge le informazioni personali degli utenti del
                sito web www.ristorantetennisgourmet.it, in conformità al Regolamento
                Generale sulla Protezione dei Dati (GDPR) UE 2016/679 e al D.Lgs. 196/2003
                come modificato dal D.Lgs. 101/2018.
              </p>
              <p className="tg-body">
                Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}
              </p>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">1. Titolare del Trattamento</h3>
              <div className="tg-body space-y-2">
                <p>
                  <strong>Tennis Gourmet</strong>
                </p>
                <p>Via Gregorini 89, 23017 Morbegno (SO)</p>
                <p>
                  Telefono:{" "}
                  <a href="tel:0342330685" className="hover:text-tennis-400 underline">
                    0342 330685
                  </a>
                </p>
                <p>
                  Email:{" "}
                  <a
                    href="mailto:info@ristorantetennisgourmet.it"
                    className="hover:text-tennis-400 underline"
                  >
                    info@ristorantetennisgourmet.it
                  </a>
                </p>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">2. Dati Personali Raccolti</h3>
              <p className="tg-body mb-4">
                Attraverso il modulo di contatto presente sul nostro sito web, raccogliamo
                i seguenti dati personali:
              </p>
              <ul className="tg-body list-disc space-y-2 pl-6">
                <li>
                  <strong>Dati obbligatori:</strong> Nome, Cognome, Indirizzo email,
                  Oggetto del messaggio, Contenuto del messaggio
                </li>
                <li>
                  <strong>Dati facoltativi:</strong> Numero di telefono
                </li>
                <li>
                  <strong>Dati tecnici automatici:</strong> Indirizzo IP, User Agent del
                  browser, Data e ora di invio
                </li>
              </ul>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">3. Finalità e Base Giuridica del Trattamento</h3>
              <div className="tg-body space-y-4">
                <div>
                  <p>
                    <strong>Finalità:</strong>
                  </p>
                  <ul className="mt-2 list-disc space-y-1 pl-6">
                    <li>
                      Rispondere alle richieste di informazioni inviate tramite il modulo
                      di contatto
                    </li>
                    <li>Fornire assistenza e supporto ai clienti</li>
                    <li>
                      Gestire prenotazioni e comunicazioni relative ai servizi offerti
                    </li>
                  </ul>
                </div>
                <div>
                  <p>
                    <strong>Base giuridica:</strong>
                  </p>
                  <p>
                    Il trattamento è basato sul consenso dell'interessato (art. 6, par. 1,
                    lett. a) del GDPR) e sull'interesse legittimo del titolare a
                    rispondere alle richieste ricevute.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">4. Modalità di Trattamento</h3>
              <div className="tg-body space-y-4">
                <p>
                  I dati personali sono trattati con strumenti automatizzati per il tempo
                  strettamente necessario a conseguire gli scopi per cui sono stati
                  raccolti.
                </p>
                <p>
                  <strong>Archiviazione:</strong> I dati vengono memorizzati in un
                  database sicuro sul server del sito web.
                </p>
                <p>
                  <strong>Comunicazioni email:</strong> I dati vengono utilizzati per:
                </p>
                <ul className="list-disc space-y-1 pl-6">
                  <li>Inviare notifiche al personale di Tennis Gourmet</li>
                  <li>Inviare una conferma automatica di ricezione all'utente</li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">5. Periodo di Conservazione</h3>
              <p className="tg-body">
                I dati personali raccolti tramite il modulo di contatto vengono conservati
                per un periodo massimo di <strong>2 anni</strong> dalla data di invio,
                salvo diversa necessità legale o richiesta specifica dell'interessato per
                la cancellazione anticipata.
              </p>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">6. Destinatari dei Dati</h3>
              <div className="tg-body space-y-2">
                <p>I dati personali possono essere comunicati a:</p>
                <ul className="list-disc space-y-1 pl-6">
                  <li>
                    Personale autorizzato di Tennis Gourmet per la gestione delle
                    richieste
                  </li>
                  <li>
                    Fornitori di servizi tecnici per la manutenzione del sito web (solo se
                    necessario)
                  </li>
                  <li>Autorità competenti, quando richiesto dalla legge</li>
                </ul>
                <p className="mt-4">
                  I dati non vengono trasferiti a paesi terzi al di fuori dell'Unione
                  Europea.
                </p>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">7. Diritti dell'Interessato</h3>
              <div className="tg-body space-y-4">
                <p>In conformità al GDPR, l'interessato ha diritto di:</p>
                <ul className="list-disc space-y-2 pl-6">
                  <li>
                    <strong>Accesso:</strong> Ottenere conferma dell'esistenza dei propri
                    dati e riceverne copia
                  </li>
                  <li>
                    <strong>Rettifica:</strong> Richiedere la correzione di dati inesatti
                    o incompleti
                  </li>
                  <li>
                    <strong>Cancellazione:</strong> Richiedere la cancellazione dei propri
                    dati ("diritto all'oblio")
                  </li>
                  <li>
                    <strong>Limitazione:</strong> Richiedere la limitazione del
                    trattamento
                  </li>
                  <li>
                    <strong>Portabilità:</strong> Ricevere i propri dati in formato
                    strutturato
                  </li>
                  <li>
                    <strong>Opposizione:</strong> Opporsi al trattamento dei propri dati
                  </li>
                  <li>
                    <strong>Revoca del consenso:</strong> Revocare il consenso in
                    qualsiasi momento
                  </li>
                </ul>
                <p className="mt-4">
                  Per esercitare questi diritti, contattare Tennis Gourmet all'indirizzo
                  email:
                  <a
                    href="mailto:info@ristorantetennisgourmet.it"
                    className="hover:text-tennis-400 ml-1 underline"
                  >
                    info@ristorantetennisgourmet.it
                  </a>
                </p>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">8. Sicurezza dei Dati</h3>
              <p className="tg-body">
                Tennis Gourmet adotta misure tecniche e organizzative appropriate per
                proteggere i dati personali da accessi non autorizzati, alterazioni,
                divulgazioni o distruzioni. Il sito web utilizza protocolli di sicurezza
                standard per la trasmissione e l'archiviazione dei dati.
              </p>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">9. Cookie</h3>
              <div className="tg-body space-y-2">
                <p>
                  Il sito web può utilizzare cookie tecnici necessari per il funzionamento
                  del sito. Questi cookie non richiedono consenso specifico in quanto
                  strettamente necessari.
                </p>
                <p>
                  Per maggiori informazioni sui cookie utilizzati, consultare la nostra{" "}
                  <Link
                    to="/cookie_policy"
                    className="hover:text-tennis-400 underline transition-colors"
                  >
                    Cookie Policy
                  </Link>
                  .
                </p>
              </div>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">10. Reclami</h3>
              <p className="tg-body">
                L'interessato ha il diritto di presentare reclamo al Garante per la
                Protezione dei Dati Personali (www.gpdp.it) qualora ritenga che il
                trattamento dei propri dati personali avvenga in violazione della
                normativa vigente.
              </p>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">11. Modifiche alla Privacy Policy</h3>
              <p className="tg-body">
                Tennis Gourmet si riserva il diritto di modificare la presente informativa
                sulla privacy. Le modifiche saranno pubblicate su questa pagina con
                indicazione della data di ultimo aggiornamento.
              </p>
            </div>

            <div>
              <h3 className="tg-h4 mb-4">12. Contatti</h3>
              <div className="tg-body space-y-2">
                <p>
                  Per qualsiasi domanda relativa alla presente informativa sulla privacy o
                  per esercitare i propri diritti, contattare:
                </p>
                <div className="bg-tennis-900/10 mt-4 rounded-lg p-4">
                  <p>
                    <strong>Tennis Gourmet</strong>
                  </p>
                  <p>Via Gregorini 89, 23017 Morbegno (SO)</p>
                  <p>
                    Telefono:{" "}
                    <a href="tel:0342330685" className="hover:text-tennis-400 underline">
                      0342 330685
                    </a>
                  </p>
                  <p>
                    Email:{" "}
                    <a
                      href="mailto:info@ristorantetennisgourmet.it"
                      className="hover:text-tennis-400 underline"
                    >
                      info@ristorantetennisgourmet.it
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
